import SelectDivision from '@/components/SelectDivision'
import $ from 'jquery'
import jwt_decode from 'jwt-decode'
import moment from 'moment'
import queryString from 'query-string'
import { v4 as uuidv4 } from 'uuid'
import MessageBubble from './MessageBubble.vue'
export default {
  components: {
    MessageBubble,
    SelectDivision
  },
  computed: {
    moment() {
      return moment
    },
    lg() {
      return this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl
    }
  },
  data() {
    return {
      showDivision: false,
      redirecturl:
        'https://tha-adfsqa.mmthqa.com/adfs/oauth2/authorize?response_type=id_token%20token&client_id=7c7f863b-3095-41bf-adf5-62698f77e643&state=TmVzQlMxblBrcF9LVUhHSS5tQ2dQVlZnZGV6cmxIeHFhVWphcTh4Z25xYmlQ&redirect_uri=https://sthqn0001.mmth-intranet-qa.co.th:55500/livechat&scope=openid%20profile%20email%20allatclaims%20role&nonce=TmVzQlMxblBrcF9LVUhHSS5tQ2dQVlZnZGV6cmxIeHFhVWphcTh4Z25xYmlQ',
      input: '',
      quick_replies: '',
      prevHeight: 0,
      showToBottom: false,
      loading: false,
      imgtest:
        'https://cdn3.vectorstock.com/i/1000x1000/46/72/person-gray-photo-placeholder-man-material-design-vector-23804672.jpg',

      windowSize: null
      // messages: [
      // 	{
      // 		"actor": 'answer',
      // 		"text":"น้องมิต สวัสดีค่ะ ต้องการสอบถามข้อมูลหรือปัญหาเกี่ยวกับด้านใด สามารถกดปุ่มด้านล่างเพื่อเริ่มสนทนาได้เลยค่ะ",
      // 		"buttons":[
      // 			{
      // 				"title":"IT division",
      // 				"type":"postback",
      // 				"payload":"IT division"
      // 			},
      // 			{
      // 				"title":"HR division",
      // 				"type":"postback",
      // 				"payload":"HR division"
      // 			},
      // 			{
      // 				"title":"ICIA division",
      // 				"type":"postback",
      // 				"payload":"ICIA division"
      // 			}
      // 		],
      // 		"type":"button"
      // 	}
      // ]
    }
  },
  beforeCreate() {
    if (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
      this.$store.state.bgcolor = '#efefef'
    }
  },
  beforeDestroy() {
    this.$store.state.bgcolor = 'white'
  },
  computed: {
    messages: {
      get() {
        return this.$store.state.messages
      },
      set(val) {
        this.$store.commit('UPDATE_MESSAGES', val)
      }
    },
    userid: {
      get() {
        return this.$store.state.userid
      },
      set(val) {
        this.$store.commit('UPDATE_USERID', val)
      }
    }
  },
  created() {
    var parsed = queryString.parseUrl(this.redirecturl).query

    parsed.nonce = uuidv4().replace(/-/g, '')
    parsed.state = uuidv4().replace(/-/g, '')
    //   'https://tha-adfsqa.mmthqa.com/adfs/oauth2/authorize?response_type=id_token%20token&client_id=7c7f863b-3095-41bf-adf5-62698f77e643&state=TmVzQlMxblBrcF9LVUhHSS5tQ2dQVlZnZGV6cmxIeHFhVWphcTh4Z25x&redirect_uri=https://sthqn0001.mmth-intranet-qa.co.th:55500/livechat&scope=openid%20profile%20email%20allatclaims%20role&nonce=TmVzQlMxblBrcF9LVUhHSS5tQ2dQVlZnZGV6cmxIeHFhVWphcTh4Z25xYmlQ
    const url =
      'https://tha-adfsqa.mmthqa.com/adfs/oauth2/authorize?' + queryString.stringify(parsed)
    const token = this.$route.hash.replace('#access_token=')
    try {
      if (token) {
        const decoded = jwt_decode(token)
        if (decoded.upn) {
          this.userid = decoded.upn
        } else {
          // location.assign(url)
        }
      }
    } catch (err) {
      console.error(err)
    }
  },
  mounted() {
    document.getElementById('chatbox').addEventListener('scroll', () => {
      var chatboxheight =
        $('#chatbox').prop('scrollHeight') - document.getElementById('chatbox').offsetHeight
      var result = chatboxheight - $('#chatbox').scrollTop()
      if (result > 300) {
        this.showToBottom = true
      } else {
        this.showToBottom = false
      }
    })

    let vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    this.sendMessage({ title: 'zwiz_welcome', payload: 'zwiz_welcome' })
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    },
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height
    },
    enter(element) {
      const { height } = getComputedStyle(element)
      element.style.height = this.prevHeight
      setTimeout(() => {
        element.style.height = height
      })
    },
    afterEnter(element) {
      element.style.height = 'auto'
    },

    scrollToBottom() {
      var chatbox = $('#chatbox')
      var offset = document.getElementById('chatbox').offsetHeight
      chatbox.animate(
        {
          scrollTop: chatbox.prop('scrollHeight') - offset
        },
        150
      )
    },
    logout() {
      localStorage.setItem('user', '')
      this.$router.push('Login')
    },
    async sendMessage(message) {
      // console.log(message)

      const vm = this

      vm.input = ''
      try {
        vm.messages = [
          ...(vm.messages || []),
          {
            actor: 'question',
            type: 'text',
            text: message.title
          }
        ]
        const { messages, quick_replies } = await vm.$store.dispatch('sendMessage', {
          message,
          messages: vm.messages,
          userid: vm.userid
        })

        vm.messages = [
          ...vm.messages,
          ...messages.map(message => {
            return {
              actor: 'answer',
              ...message
            }
          })
        ]
        vm.quick_replies = quick_replies
      } catch (error) {
        console.error(error)
      }
      vm.$nextTick(() => {
        vm.scrollToBottom()
      })
    }
  }
}
